import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import BaseSlotWinningsController from 'Engine/base/winings/BaseSlotWinningsController';
import eEventTypes from '../enums/eEventTypes';

export default class WinLinesProvider extends BaseSlotWinningsController {
  constructor(config) {
    super(config);
  }

  showNextWin() {
    let index = this.currentWinId % this.winningData.length;
    let currentWinData = this.winningData[index];
    if (currentWinData) {
      GlobalDispatcher.dispatch(eEventTypes.EET_WINNINGS_CONTROLLER__SLOW_WIN, currentWinData);
      this.currentWinId++;
      if (this.currentWinId === this.winningData.length) {
        GlobalDispatcher.dispatch(eEventTypes.EET_WINNINGS_CONTROLLER__ALL_WINNINGS_COMPLETE);
      }
      this.timeout = setTimeout(() => {
        this.showNextWin();
      },currentWinData.isScatter ? this.config.nextScatterWinTimeout : this.config.nextWinTimeout);
    }
  }
}
